<template>
    <section>
        <div class="py-5 ">
            <div class="container news_section">
                <div class="row  ">
                    <div class="col-12 mb-4">
                      
                        <h1 class=" blueFont float-end">
                            الأخبار
                        </h1>
                    
                        <a @click="ToNews1" class="read_more float-start">كل الأخبار <i class="bi bi-arrow-left"></i></a>
                    </div>
                    <div class="col-12">
                        <div id="carouselNewsHome" class="carousel slide" data-bs-ride="true">
                            <div class="carousel-indicators">
                                <button type="button" data-bs-target="#carouselNewsHome" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                                <button type="button" data-bs-target="#carouselNewsHome" data-bs-slide-to="1" aria-label="Slide 2"></button>
                            </div>
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="main_news">
                                                <div class="card pointer" @click="ToNews1">
                                                    <img src="@/assets/images/smartrecord.jpg" class="img-fluid shadow-sm" alt="">
                                                    <div class="card-body">
                                                    <h2 class="card-title">	تشغيل (السجل المدنى الذكى) 
                                                        </h2>
                                                    <p class="card-text">
                                                        تشغيل (السجل المدنى الذكى) 
                                                        </p>
                                                    </div>

                                                    <div class="card-footer">
                                                    <a @click="ToNews1"  class="read_news fw-semibold"><i class="bi bi-newspaper"></i>  &nbsp; قراءة الخبر </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-6 news_group">
                                            <div class="row row-cols-1 row-cols-sm-2 g-4">
                                                <div class="col-sm">
                                                    <div class="card pointer" @click="ToNews2">
                                                        <img src="@/assets/images/IdealCenters/Center04/01.jpg"  class="card-img-top shadow"  height="235"  alt="...">
                                                        <div class="innerCard">
                                                            <div class="card-body">
                                                                <h5 class="card-title">
                                                                <a @click="ToNews2"  style="color:white;text-decoration:none" >  	تجهيز اسطول من الحافلات المُجهزة فنياً ولوجستياً (مراكز تكنولوجية مُتنقلة)  </a>
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm">
                                                    <div class="card pointer" @click="ToNews3">
                                                        <img src="@/assets/images/tablet.jpg"  height="235" class="card-img-top shadow" alt="...">
                                                        <div class="innerCard">
                                                            <div class="card-body">
                                                                <h5 class="card-title">
                                                                
                                                                    <a @click="ToNews3"  style="color:white;text-decoration:none" >   		إستحداث جهاز محمول (تابلت) يُمكن الإنتقال به بمأموريات القطاع الخارجية   </a>
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            
                                                <div class="col-sm">
                                                    <div class="card pointer" @click="ToNews4">
                                                        <img src="@/assets/images/news3.jpg" height="235" class="card-img-top shadow" alt="...">
                                                        <div class="innerCard">
                                                            <div class="card-body">
                                                                <h5 class="card-title">
                                                                <a @click="ToNews4" style="color:white;text-decoration:none" >  	 	 	خدمة الـ (Call-Center) على الارقام (15340 - 15341 - 16582) حتى الساعة    9 م   </a>
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm">
                                                    <div class="card pointer" @click="ToNews5">
                                                        <img src="@/assets/images/news3.jpg" height="235" class="card-img-top shadow" alt="...">
                                                        <div class="innerCard">
                                                            <div class="card-body">
                                                                <h5 class="card-title">
                                                                <a  @click="ToNews5"  style="color:white;text-decoration:none" >  	 	   تفعيل خط  اخر إضافى (15341) مُخصص لتلقى إتصالات (ذوى الهمم  - الحالات الإنسانية والمرضية – أسر الشهداء من الدرجة الأولى)    </a>
                                                            
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
        
                                <div class="carousel-item ">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="main_news">
                                                <div class="card pointer" @click="ToNews1">
                                                    <img src="@/assets/images/smartrecord.jpg" class="img-fluid shadow-sm" alt="">
                                                    <div class="card-body">
                                                    <h2 class="card-title">	تشغيل (السجل المدنى الذكى) 
                                                        </h2>
                                                    <p class="card-text">
                                                        تشغيل (السجل المدنى الذكى) 
                                                        </p>
                                                    </div>

                                                    <div class="card-footer">
                                                    <a @click="ToNews1"  class="read_news fw-semibold"><i class="bi bi-newspaper"></i>  &nbsp; قراءة الخبر </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 news_group">
                                            <div class="row row-cols-1 row-cols-sm-2 g-4">
                                                <div class="col-sm">
                                                    <div class="card pointer">
                                                        <img src="@/assets/images/news2.jpg" class="card-img-top shadow" alt="...">
                                                        <div class="innerCard">
                                                            <div class="card-body">
                                                                <h5 class="card-title">
                                                                    <a @click="ToNews5" href="#" style="color:white;text-decoration:none" >  	 	  تخصيص (مكتب لذوى الهمم - كبار السن- المرضى) بديوان القطاع والمنافذ الجغرافية     </a>
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm">
                                                    <div class="card pointer" @click="ToNews8">
                                                        <img src="@/assets/images/tablet.jpg" height="235" class="card-img-top shadow" alt="...">
                                                        <div class="innerCard">
                                                            <div class="card-body">
                                                                <h5 class="card-title">
                                                                
                                                                    <a @click="ToNews8"  style="color:white;text-decoration:none" >  	 	 إيفاد مأموريات خاصة بصورة مستمرة للـحالات الإنسانية بالـ (مستشفيات – منازل) لتصويرهم فنياً    </a>
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            
                                                <div class="col-sm">
                                                    <div class="card pointer" @click="ToNews9">
                                                        <img src="@/assets/images/innerImage.jpg"  height="235" class="card-img-top shadow" alt="...">
                                                        <div class="innerCard">
                                                            <div class="card-body">
                                                                <h5 class="card-title">
                                                                    
                                                                    <a @click="ToNews9" style="color:white;text-decoration:none" >  	 		تفعيل بروتوكول التعاون الموقع مع وزارة الخارجية وإستخراج بطاقات رقم قومى للمواطنين المقيمين خارج البلاد   </a>
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
       
                            </div>
       
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: 'NewsComp',
  created(){
    window.scrollTo({ top: 0, behavior: "smooth" });
   },
  methods:{
    ToNews1(){
        this.$router.push({name: 'news1'})
    },
    ToNews2(){
        this.$router.push({name: 'news2'})
    },
    ToNews3(){
        this.$router.push({name: 'news3'})
    }
    ,
    ToNews4(){
        this.$router.push({name: 'news4'})
    },
    ToNews5(){
        this.$router.push({name: 'news5'})
    },
    ToNews6(){
        this.$router.push({name: 'news6'})
    },
    ToNews7(){
        this.$router.push({name: 'news7'})
    },
    ToNews8(){
        this.$router.push({name: 'news8'})
    },
    ToNews9(){
        this.$router.push({name: 'news9'})
    }
  }
}
</script>